module.exports = __webpack_public_path__ + "static/media/heart4.2f10772b.svg";